/**
 * SEO keyword landing configs.
 *
 * Google par log jo bhi popular query search karte hain (Shillong Teer,
 * Morning Teer, FR/SR, Common Number, House/Ending, Dream, Previous,
 * Target etc.) — un sab ke liye alag URL banayi gayi hai.
 *
 * Har entry me:
 *   - path      : URL (React Router route)
 *   - h1        : Visible page heading (usually screen-reader-only)
 *   - title     : <title> tag / OG title
 *   - description : meta description / OG description
 *   - variant   : which page component to render — home | common | previous | dream
 *
 * Home component & the sub-page components use `useKeywordSeo()` (below)
 * to look up the config that matches the current pathname and apply it.
 */

export const KEYWORD_LANDINGS = [
  // ---------------- HIGH-PRIORITY exact-match keywords ------------------
  // Ye 9 keywords public sabse zyada Google me search karta hai.
  {
    path: "/morning-teer",
    variant: "home",
    h1: "Morning Teer — Live F/R and S/R Result Today",
    title: "Morning Teer | Morning Teer Official Result",
    description:
      "Morning Teer — Official F/R (10:30 AM) and S/R (11:30 AM) live result of the Shillong Morning Teer archery draw, updated every morning.",
  },
  {
    path: "/morning-teer-result",
    variant: "home",
    h1: "Morning Teer Result — F/R and S/R Winning Numbers",
    title: "Morning Teer Result | Official Morning Teer",
    description:
      "Morning Teer Result today — check the latest F/R and S/R winning numbers of the Shillong Morning Teer draw, published as soon as the counter announces.",
  },
  {
    path: "/shillong-morning-teer",
    variant: "home",
    h1: "Shillong Morning Teer — Live Result & Info",
    title: "Shillong Morning Teer | Official Morning Teer",
    description:
      "Shillong Morning Teer — live F/R and S/R result, common numbers, previous results and everything about the traditional archery-based Morning Teer draw in Shillong.",
  },
  {
    path: "/morning-shillong-teer",
    variant: "home",
    h1: "Morning Shillong Teer — Today's F/R and S/R Result",
    title: "Morning Shillong Teer Result | Official Morning Teer",
    description:
      "Morning Shillong Teer today — live F/R (10:30 AM) and S/R (11:30 AM) result of the Shillong Morning Teer archery draw.",
  },
  {
    path: "/sunday-morning-teer",
    variant: "home",
    h1: "Sunday Morning Teer — Live Result Today",
    title: "Sunday Morning Teer | Official Morning Teer",
    description:
      "Sunday Morning Teer — live F/R and S/R Shillong Morning Teer result for the Sunday edition of the traditional archery draw.",
  },
  {
    path: "/sunday-morning-teer-result",
    variant: "home",
    h1: "Sunday Morning Teer Result Today",
    title: "Sunday Morning Teer Result | Official Morning Teer",
    description:
      "Sunday Morning Teer Result today — live F/R and S/R winning numbers for the Sunday edition of the Shillong Morning Teer draw.",
  },
  {
    path: "/morning-sunday-teer",
    variant: "home",
    h1: "Morning Sunday Teer — Live F/R and S/R Result",
    title: "Morning Sunday Teer | Official Morning Teer",
    description:
      "Morning Sunday Teer — live Shillong Morning Teer Sunday result, F/R (10:30 AM) and S/R (11:30 AM) winning numbers of the traditional archery draw.",
  },

  // ---------------- Result / Home aliases -------------------------------
  {
    path: "/morning-teer-result-today",
    variant: "home",
    h1: "Morning Teer Result Today — Live F/R and S/R Numbers",
    title: "Morning Teer Result Today | Official Morning Teer",
    description:
      "Check Morning Teer Result Today — live F/R (10:30 AM) and S/R (11:30 AM) winning numbers for the Shillong Morning Teer draw, updated every morning.",
  },
  {
    path: "/shillong-morning-teer-result",
    variant: "home",
    h1: "Shillong Morning Teer Result — F/R and S/R Winning Numbers",
    title: "Shillong Morning Teer Result Today | Official Morning Teer",
    description:
      "Shillong Morning Teer Result today — first round (F/R) and second round (S/R) winning numbers from the official Shillong Morning Teer draw.",
  },
  {
    path: "/morning-teer-live-result",
    variant: "home",
    h1: "Morning Teer Live Result — Real-Time F/R and S/R Numbers",
    title: "Morning Teer Live Result Today | F/R & S/R | Official Morning Teer",
    description:
      "Watch the Morning Teer Live Result as soon as the counter announces the F/R and S/R winning numbers. Fastest Shillong Morning Teer live updates.",
  },
  {
    path: "/shillong-teer-result",
    variant: "home",
    h1: "Shillong Teer Result Today — Morning F/R and S/R",
    title: "Shillong Teer Result Today | Morning F/R S/R | Official Morning Teer",
    description:
      "Shillong Teer Result today — live morning F/R and S/R winning numbers of the Shillong Morning Teer draw, updated as soon as the counter announces them.",
  },
  {
    path: "/meghalaya-morning-teer",
    variant: "home",
    h1: "Meghalaya Morning Teer Result — Shillong Live F/R and S/R",
    title: "Meghalaya Morning Teer Result Live | Official Morning Teer",
    description:
      "Meghalaya Morning Teer Result — live Shillong Morning Teer F/R (10:30 AM) and S/R (11:30 AM) winning numbers from the traditional archery draw.",
  },
  {
    path: "/morning-sunday-teer-result",
    variant: "home",
    h1: "Morning Sunday Teer Result — Live F/R and S/R",
    title: "Morning Sunday Teer Result Today | Official Morning Teer",
    description:
      "Morning Sunday Teer Result today — live F/R and S/R winning numbers for the Sunday edition of the Shillong Morning Teer draw.",
  },
  {
    path: "/morning-teer-10-30-am",
    variant: "home",
    h1: "Morning Teer 10:30 AM Result — First Round (F/R)",
    title: "Morning Teer 10:30 AM Result (F/R) | Official Morning Teer",
    description:
      "Morning Teer 10:30 AM (First Round / F/R) result of the Shillong Morning Teer draw — announced daily around 10:30 AM.",
  },
  {
    path: "/morning-teer-11-30-am",
    variant: "home",
    h1: "Morning Teer 11:30 AM Result — Second Round (S/R)",
    title: "Morning Teer 11:30 AM Result (S/R) | Official Morning Teer",
    description:
      "Morning Teer 11:30 AM (Second Round / S/R) result of the Shillong Morning Teer draw — announced daily around 11:30 AM.",
  },
  {
    path: "/morning-teer-fr-sr-result",
    variant: "home",
    h1: "Morning Teer F/R and S/R Result Today",
    title: "Morning Teer F/R & S/R Result Today | Official Morning Teer",
    description:
      "Morning Teer F/R (First Round) and S/R (Second Round) result today — Shillong Morning Teer winning numbers updated in real time from the counter.",
  },
  {
    path: "/khasi-hills-morning-teer",
    variant: "home",
    h1: "Khasi Hills Morning Teer Result Today",
    title: "Khasi Hills Morning Teer Result | Official Morning Teer",
    description:
      "Khasi Hills Morning Teer Result — Shillong Morning Teer F/R and S/R winning numbers from the traditional Meghalaya archery draw.",
  },

  // ---------------- Common Number aliases -------------------------------
  {
    path: "/morning-teer-common-number",
    variant: "common",
    h1: "Morning Teer Common Number — Direct, House and Ending Picks",
    title: "Morning Teer Common Number Today | Official Morning Teer",
    description:
      "Morning Teer Common Number today — Direct, House and Ending picks for both F/R and S/R rounds of the Shillong Morning Teer draw.",
  },
  {
    path: "/shillong-morning-teer-common-number",
    variant: "common",
    h1: "Shillong Morning Teer Common Number Today",
    title: "Shillong Morning Teer Common Number | Official Morning Teer",
    description:
      "Shillong Morning Teer Common Number today — Direct, House and Ending numbers for the F/R and S/R Shillong Morning Teer draws.",
  },
  {
    path: "/morning-teer-house-ending",
    variant: "common",
    h1: "Morning Teer House and Ending Number",
    title: "Morning Teer House Number & Ending Number | Official Morning Teer",
    description:
      "Morning Teer House and Ending numbers — study today's House digit and Ending digit picks for the F/R and S/R Shillong Morning Teer draws.",
  },
  {
    path: "/morning-teer-house-number",
    variant: "common",
    h1: "Morning Teer House Number Today",
    title: "Morning Teer House Number Today | Official Morning Teer",
    description:
      "Morning Teer House Number today — the recommended House digit for both F/R and S/R Shillong Morning Teer rounds, updated daily.",
  },
  {
    path: "/morning-teer-ending-number",
    variant: "common",
    h1: "Morning Teer Ending Number Today",
    title: "Morning Teer Ending Number Today | Official Morning Teer",
    description:
      "Morning Teer Ending Number today — the recommended Ending digit for both F/R and S/R Shillong Morning Teer rounds, refreshed daily.",
  },
  {
    path: "/morning-teer-hit-number",
    variant: "common",
    h1: "Morning Teer Hit Number Today",
    title: "Morning Teer Hit Number Today | Official Morning Teer",
    description:
      "Morning Teer Hit Number today — high-frequency picks derived from recent Shillong Morning Teer result trends.",
  },

  // ---------------- Previous Result aliases -----------------------------
  {
    path: "/morning-teer-previous-result",
    variant: "previous",
    h1: "Morning Teer Previous Result — Full Historical Archive",
    title: "Morning Teer Previous Result Archive | Official Morning Teer",
    description:
      "Morning Teer Previous Result archive — filter every historical Shillong Morning Teer F/R and S/R winning number by date.",
  },
  {
    path: "/shillong-morning-teer-previous-result",
    variant: "previous",
    h1: "Shillong Morning Teer Previous Result — All Past F/R and S/R",
    title: "Shillong Morning Teer Previous Result | Official Morning Teer",
    description:
      "Shillong Morning Teer Previous Result — browse the full archive of past F/R and S/R winning numbers filtered by any date.",
  },
  {
    path: "/morning-teer-result-history",
    variant: "previous",
    h1: "Morning Teer Result History — Complete Archive",
    title: "Morning Teer Result History Archive | Official Morning Teer",
    description:
      "Complete Morning Teer Result History — search past daily F/R and S/R winning numbers of the Shillong Morning Teer draw by date.",
  },
  {
    path: "/morning-teer-old-result",
    variant: "previous",
    h1: "Morning Teer Old Result Archive",
    title: "Morning Teer Old Result | Official Morning Teer",
    description:
      "Morning Teer Old Result — look up any past Shillong Morning Teer F/R and S/R winning number using the date filter.",
  },

  // ---------------- Dream Number aliases --------------------------------
  {
    path: "/morning-teer-dream-number",
    variant: "dream",
    h1: "Morning Teer Dream Number — Traditional Dream to Number Guide",
    title: "Morning Teer Dream Number Look-up | Official Morning Teer",
    description:
      "Morning Teer Dream Number — traditional keyword-to-number mappings. Look up what your dream (water, fish, snake, wedding…) means in the Shillong Morning Teer chart.",
  },
  {
    path: "/shillong-morning-teer-dream-number",
    variant: "dream",
    h1: "Shillong Morning Teer Dream Number Guide",
    title: "Shillong Morning Teer Dream Number | Official Morning Teer",
    description:
      "Shillong Morning Teer Dream Number look-up — enter a dream keyword and see the traditional two-digit number linked to it.",
  },
  {
    path: "/morning-teer-lucky-number",
    variant: "dream",
    h1: "Morning Teer Lucky Number — Today's Personal Pick",
    title: "Morning Teer Lucky Number Today | Official Morning Teer",
    description:
      "Morning Teer Lucky Number — dream-based two-digit picks used by Shillong Morning Teer followers as a personal reference.",
  },

  // ---------------- Target Number aliases -------------------------------
  {
    path: "/morning-teer-target-number-today",
    variant: "target",
    h1: "Morning Teer Target Number Today",
    title: "Morning Teer Target Number Today | Official Morning Teer",
    description:
      "Morning Teer Target Number today — statistically shortlisted two-digit picks for the F/R and S/R Shillong Morning Teer rounds.",
  },
];

/**
 * Lookup a landing config by URL path.
 */
export function findKeywordConfig(pathname) {
  return KEYWORD_LANDINGS.find((k) => k.path === pathname) || null;
}
